<template lang="pug">
  div
    mt-datetime-picker(
      v-model="currDate"
      type="date"
      year-format="{value} 年"
      month-format="{value} 月"
      date-format="{value} 日"
      :startDate='startDate'
      :endDate='endDate'
      @confirm='confirm'
    )
</template>

<script>
export default {
  props: ['startDate', 'endDate', 'currDate'],
  methods: {
    confirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base';
.mint-datetime-action {
  color: @main_color;
  text-align: right;
  padding-right: 2em;
}
.picker-center-highlight {
  &::after,
  &::before {
    background-color: @main_color;
  }
}
.mint-datetime-cancel {
  display: none;
}
</style>
